import { Typography } from '@material-ui/core';
import {
  EditProfileResumeContentListContainer,
  EditProfileResumeHiddenContentText,
} from '../EditProfileMediaResume.styles';
import { IRepresentativeProfilesTalentLevelResumeCategories } from 'shared/interfaces/IRepresentativesEditProfile';
import { useEditProfileMediaResumeUpdater } from '../../../hooks/useEditProfileMediaResumeUpdater';
import { DndContext, DragOverlay } from '@dnd-kit/core';
import { useEditProfileMediaResumeDnd } from '../../../hooks/useEditProfileMediaResumeDnd';
import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { SortableContext } from '@dnd-kit/sortable';
import EditProfileMediaResumeItem from '../EditProfileMediaResumeItem/EditProfileMediaResumeItem';

type EditProfileMediaResumeContentProps = {
  attachedResume: IRepresentativeProfilesTalentLevelResumeCategories[];
  hiddenResume: IRepresentativeProfilesTalentLevelResumeCategories[];
  profileId: string;
};

const EditProfileMediaResumeContent = ({
  attachedResume,
  hiddenResume,
  profileId,
}: EditProfileMediaResumeContentProps) => {
  const { onHideClick, onUnHideClick } = useEditProfileMediaResumeUpdater(profileId, attachedResume);
  const { attachedItems, activeId, DndProps } = useEditProfileMediaResumeDnd(profileId, attachedResume);

  return (
    <div>
      {attachedItems?.length > 0 ? (
        <DndContext {...DndProps}>
          <SortableContext items={attachedItems?.map((item) => item.category_id)}>
            <EditProfileResumeContentListContainer key={'attached'}>
              {attachedItems?.map((resume) => (
                <EditProfileMediaResumeItem
                  key={resume.category_id}
                  isAttached={true}
                  categoryName={resume.category}
                  onToggle={onHideClick}
                  credits={resume?.credits?.length}
                  id={resume.category_id}
                />
              ))}
            </EditProfileResumeContentListContainer>
          </SortableContext>
          <DragOverlay adjustScale>
            {activeId !== null && attachedItems[activeId] ? (
              <EditProfileMediaResumeItem
                key={attachedItems[activeId].category_id}
                isAttached={true}
                categoryName={attachedItems[activeId].category}
                onToggle={onHideClick}
                credits={attachedItems[activeId]?.credits?.length}
                id={attachedItems[activeId].category_id}
              />
            ) : null}
          </DragOverlay>
        </DndContext>
      ) : (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <TypographyTooltip noWrap={false} variant="h3" style={{ fontWeight: 600 }}>
            No Resume Selected
          </TypographyTooltip>
          <TypographyTooltip noWrap={false} variant="h4">
            You can select from Resume below or create a new one
          </TypographyTooltip>
        </div>
      )}

      {hiddenResume?.length > 0 ? (
        <div>
          <EditProfileResumeHiddenContentText>Hidden From Profile</EditProfileResumeHiddenContentText>
          <EditProfileResumeContentListContainer key={'hidden'}>
            {hiddenResume.map((resume) => (
              <EditProfileMediaResumeItem
                isAttached={false}
                categoryName={resume.category}
                onToggle={onUnHideClick}
                credits={resume?.credits?.length}
                id={resume.category_id}
                disableToggle={resume?.credits?.length === 0}
              />
            ))}
          </EditProfileResumeContentListContainer>
        </div>
      ) : null}
    </div>
  );
};

export default EditProfileMediaResumeContent;
